import { useQuery } from '@tanstack/react-query';
import schema from '@/schemas/recipes';

import useStore, { selectFavoriteCountryId, selectSetRecipesList } from '../client/useStore';

const parseData = (res) => {
  const parseResult = schema.safeParse(res);
  if (parseResult.success) {
    return parseResult.data;
  } else {
    console.log({ recipes: parseResult?.error.issues });
    return null;
  }
};

const useRecipes = () => {
  const setRecipesList = useStore(selectSetRecipesList);
  const favoriteCountryId = useStore(selectFavoriteCountryId);

  return useQuery({
    queryKey: ['recipes'],
    queryFn: async () => {
      const response = await fetch(`/data/${favoriteCountryId}/recipes.json`);
      if (!response.ok) {
        throw new Error(`No se pudo cargar el archivo recetas.`);
      }
      const res = await response.json();
      const parseResult = parseData(res);

      if (parseResult.length) {
        setRecipesList(parseResult);
        return parseResult;
      }
      return null;
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !!favoriteCountryId, // fire this only if we have a defined favoriteCountryId
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export default useRecipes;
